"use strict";

exports.__esModule = true;
exports.StaticFlexGrid = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FlexRow = require("./FlexRow");
var _FlexSpacer = require("./FlexSpacer");
var _excluded = ["width", "height", "itemWidth", "itemHeight", "columnGutter", "rowGutter", "itemCount", "renderItem", "getRowProps", "style"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var StaticFlexGridContainer = _styledComponents["default"].div.withConfig({
  displayName: "StaticFlexGrid__StaticFlexGridContainer",
  componentId: "sc-45p9p3-0"
})(["position:relative;overflow:hidden;"]);

/**
 * Renders a static grid of items.
 */
var StaticFlexGrid = exports.StaticFlexGrid = /*#__PURE__*/function (_React$PureComponent) {
  function StaticFlexGrid() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  _inheritsLoose(StaticFlexGrid, _React$PureComponent);
  var _proto = StaticFlexGrid.prototype;
  _proto.getItemsPerRow = function getItemsPerRow() {
    var _this$props = this.props,
      itemWidth = _this$props.itemWidth,
      columnGutter = _this$props.columnGutter,
      width = _this$props.width;
    return Math.floor(width / (itemWidth + columnGutter)) || 1;
  };
  _proto.getVisibleRowCount = function getVisibleRowCount() {
    var _this$props2 = this.props,
      itemHeight = _this$props2.itemHeight,
      rowGutter = _this$props2.rowGutter,
      height = _this$props2.height;
    return Math.ceil(height / (itemHeight + rowGutter)) || 1;
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      width = _this$props3.width,
      height = _this$props3.height,
      itemWidth = _this$props3.itemWidth,
      itemHeight = _this$props3.itemHeight,
      columnGutter = _this$props3.columnGutter,
      rowGutter = _this$props3.rowGutter,
      itemCount = _this$props3.itemCount,
      renderItem = _this$props3.renderItem,
      getRowProps = _this$props3.getRowProps,
      style = _this$props3.style,
      extra = _objectWithoutPropertiesLoose(_this$props3, _excluded);
    var items = [];
    var rowCount = this.getVisibleRowCount();
    var top = 0;
    var left = 0;
    for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      var _style = {
        top: top,
        left: left,
        width: width,
        height: itemHeight + rowGutter
      };
      items.push(this.renderRow(rowIndex, _style));
      top += itemHeight + rowGutter;
    }
    return /*#__PURE__*/_react["default"].createElement(StaticFlexGridContainer, _extends({}, extra, {
      style: {
        style: style,
        width: width,
        height: height
      }
    }), items);
  };
  _proto.renderRow = function renderRow(index, style) {
    var _this$props4 = this.props,
      width = _this$props4.width,
      itemCount = _this$props4.itemCount,
      renderItem = _this$props4.renderItem,
      itemHeight = _this$props4.itemHeight,
      columnGutter = _this$props4.columnGutter,
      getRowProps = _this$props4.getRowProps;
    var itemsPerRow = this.getItemsPerRow();
    var startIndex = itemsPerRow * index;
    var items = [];
    for (var itemIndex = startIndex; itemIndex < startIndex + itemsPerRow; itemIndex++) {
      if (itemIndex >= itemCount) {
        items.push(/*#__PURE__*/_react["default"].createElement(_FlexSpacer.FlexSpacer, {
          key: itemIndex
        }));
      } else {
        items.push(renderItem({
          index: itemIndex
        }));
      }
    }
    return /*#__PURE__*/_react["default"].createElement(_FlexRow.FlexRow, _extends({
      key: index,
      gutter: columnGutter,
      width: width,
      height: itemHeight,
      style: style
    }, getRowProps(index)), items);
  };
  return StaticFlexGrid;
}(_react["default"].PureComponent);
StaticFlexGrid.defaultProps = {
  columnGutter: 16,
  rowGutter: 16,
  getRowProps: function getRowProps() {
    return {};
  }
};